const React = require('react');

/**
 * @param {import('../index.d.ts').StyleProps} props
 */
function renderStyleTag(props) {
  const {
    children,
    media,
    firstRequestInlineStyles,
    critical = false,
    renderChildrenInPlace = true,
  } = props;

  if (
    !renderChildrenInPlace
    || critical
    || firstRequestInlineStyles
    || typeof children !== 'string'
  ) {
    return null;
  }

  /** @type {React.StyleHTMLAttributes<HTMLStyleElement>} */
  const elementProps = {
    dangerouslySetInnerHTML: {
      __html: children,
    },
  };

  if (media) {
    elementProps.media = media;
  }

  return React.createElement('style', elementProps);
}

module.exports = {
  renderStyleTag,
};
